import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import axiosInstance from "../utils/axiosInstance";

/* ─── styles ─────────────────────────────────────────────────── */
const S = `
@keyframes iaFadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
@keyframes iaPop{0%{opacity:0;transform:scale(.93)}60%{transform:scale(1.02)}100%{opacity:1;transform:scale(1)}}
@keyframes iaSpin{to{transform:rotate(360deg)}}

.ia-root{font-family:'Nunito Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#0d1b2a;animation:iaFadeUp .35s ease;}
.ia-root *{box-sizing:border-box;margin:0;padding:0;}

.ia-hdr{display:flex;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;gap:12px;margin-bottom:22px;}
.ia-hdr h2{font-size:clamp(1.1rem,2.5vw,1.35rem);font-weight:800;color:#0047AB;display:flex;align-items:center;gap:8px;}
.ia-hdr p{font-size:.82rem;color:#64748b;margin-top:3px;}

.ia-btn{display:inline-flex;align-items:center;gap:6px;padding:9px 16px;border-radius:8px;border:none;font-weight:700;font-size:.83rem;cursor:pointer;transition:all .18s;font-family:inherit;}
.ia-btn-primary{background:#0047AB;color:#fff;box-shadow:0 2px 8px rgba(0,71,171,.22);}
.ia-btn-primary:hover{background:#0035a0;transform:translateY(-1px);}
.ia-btn-success{background:#20603D;color:#fff;}
.ia-btn-success:hover{background:#174f32;transform:translateY(-1px);}
.ia-btn-warning{background:#e07b00;color:#fff;}
.ia-btn-warning:hover{background:#c56e00;}
.ia-btn-danger{background:#c0392b;color:#fff;}
.ia-btn-danger:hover{background:#a93226;}
.ia-btn-outline{background:#fff;color:#0047AB;border:1.5px solid #0047AB;}
.ia-btn-outline:hover{background:#f0f6ff;}
.ia-btn-sm{padding:6px 12px;font-size:.76rem;}
.ia-btn:disabled{opacity:.45;cursor:not-allowed;transform:none!important;}

.ia-card{background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 1px 4px rgba(0,0,0,.06);overflow:hidden;margin-bottom:16px;}
.ia-card-head{padding:14px 18px;background:#f8fafc;border-bottom:1px solid #e2e8f0;display:flex;align-items:center;gap:8px;font-weight:700;font-size:.9rem;color:#1e293b;}
.ia-card-head-icon{width:32px;height:32px;border-radius:7px;background:#0047AB;color:#fff;display:flex;align-items:center;justify-content:center;font-size:.9rem;flex-shrink:0;}
.ia-card-body{padding:18px;}

.ia-label{display:block;font-size:.78rem;font-weight:700;color:#374151;margin-bottom:5px;}
.ia-input{width:100%;padding:9px 12px;border:1.5px solid #e2e8f0;border-radius:7px;font-size:.88rem;outline:none;color:#111;font-family:inherit;transition:border-color .18s;background:#fff;}
.ia-input:focus{border-color:#0047AB;box-shadow:0 0 0 3px rgba(0,71,171,.1);}
.ia-select{width:100%;padding:9px 12px;border:1.5px solid #e2e8f0;border-radius:7px;font-size:.88rem;outline:none;color:#111;font-family:inherit;background:#fff;cursor:pointer;}
.ia-select:focus{border-color:#0047AB;}
.ia-row{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:14px;margin-bottom:14px;}

.ia-summary{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:10px;margin-bottom:18px;}
.ia-sum-box{background:#fff;border:1px solid #e2e8f0;border-radius:9px;padding:14px 12px;text-align:center;}
.ia-sum-num{font-size:1.6rem;font-weight:800;line-height:1;}
.ia-sum-lbl{font-size:.68rem;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#64748b;margin-top:4px;}
.ia-progress{height:8px;background:#e2e8f0;border-radius:10px;overflow:hidden;margin-top:6px;}
.ia-progress-fill{height:100%;background:linear-gradient(90deg,#20603D,#4ade80);border-radius:10px;transition:width .4s;}

.ia-table-wrap{overflow-x:auto;border-radius:8px;border:1px solid #e2e8f0;}
.ia-table{width:100%;border-collapse:collapse;font-size:.82rem;}
.ia-table th{background:#f0f4f8;padding:9px 12px;text-align:left;font-size:.7rem;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.06em;white-space:nowrap;border-bottom:1px solid #e2e8f0;}
.ia-table td{padding:9px 12px;border-bottom:1px solid #f1f5f9;vertical-align:middle;}
.ia-table tr:last-child td{border-bottom:none;}
.ia-table tbody tr:hover{background:#f8faff;}

.ia-cb{width:17px;height:17px;accent-color:#0047AB;cursor:pointer;}

.ia-toggle{display:flex;gap:6px;}
.ia-tog-yes,.ia-tog-no{padding:5px 13px;border-radius:6px;border:1.5px solid;font-size:.76rem;font-weight:700;cursor:pointer;transition:all .15s;}
.ia-tog-yes{border-color:#20603D;color:#20603D;background:#fff;}
.ia-tog-yes.active{background:#20603D;color:#fff;}
.ia-tog-no{border-color:#c0392b;color:#c0392b;background:#fff;}
.ia-tog-no.active{background:#c0392b;color:#fff;}

.ia-badge{display:inline-block;padding:2px 9px;border-radius:20px;font-size:.68rem;font-weight:700;}
.ia-badge-gore{background:rgba(190,24,93,.1);color:#be185d;}
.ia-badge-gabo{background:rgba(0,71,171,.1);color:#0047AB;}
.ia-badge-other{background:rgba(32,96,61,.1);color:#20603D;}

.ia-filter-bar{display:flex;gap:10px;flex-wrap:wrap;align-items:center;margin-bottom:14px;}
.ia-search{display:flex;align-items:center;gap:7px;padding:0 11px;background:#fff;border:1.5px solid #e2e8f0;border-radius:8px;height:36px;flex:1;min-width:160px;}
.ia-search input{border:none;outline:none;font-size:.83rem;width:100%;font-family:inherit;color:#111;}
.ia-search i{color:#94a3b8;font-size:.85rem;}

.ia-status{display:inline-flex;align-items:center;gap:5px;padding:3px 10px;border-radius:20px;font-size:.7rem;font-weight:700;}
.ia-status-draft{background:rgba(100,116,139,.1);color:#64748b;}
.ia-status-saved{background:rgba(32,96,61,.12);color:#20603D;}
.ia-status-submitted{background:rgba(0,71,171,.12);color:#0047AB;}
.ia-status-approved{background:rgba(32,96,61,.18);color:#145a32;}
.ia-status-returned{background:rgba(192,57,43,.12);color:#c0392b;}

.ia-act-item{display:flex;align-items:center;gap:12px;padding:11px 14px;border:1.5px solid #e2e8f0;border-radius:9px;cursor:pointer;transition:all .15s;margin-bottom:6px;background:#fff;}
.ia-act-item:hover{border-color:#0047AB;background:#f0f6ff;}
.ia-act-item.selected{border-color:#0047AB;background:#f0f6ff;box-shadow:0 0 0 3px rgba(0,71,171,.1);}
.ia-act-icon{width:38px;height:38px;border-radius:8px;background:#0047AB;color:#fff;display:flex;align-items:center;justify-content:center;font-size:1rem;flex-shrink:0;}
.ia-act-body{flex:1;min-width:0;}
.ia-act-name{font-weight:700;font-size:.88rem;color:#1e293b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ia-act-meta{font-size:.74rem;color:#64748b;margin-top:2px;}

.ia-overlay{position:fixed;inset:0;background:rgba(0,0,0,.52);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);z-index:4000;display:flex;align-items:center;justify-content:center;padding:16px;animation:iaFadeUp .2s ease;}
.ia-modal{background:#fff;border:1px solid #e2e8f0;border-radius:12px;padding:28px 24px;width:100%;max-width:480px;animation:iaPop .25s ease;box-shadow:0 16px 48px rgba(0,0,0,.14);}
.ia-modal h3{font-size:1.05rem;font-weight:800;color:#0047AB;margin-bottom:18px;display:flex;align-items:center;gap:8px;}
.ia-modal-btns{display:flex;gap:10px;margin-top:20px;}
.ia-modal-btns button{flex:1;}

.ia-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 20px;gap:10px;color:#94a3b8;text-align:center;}
.ia-spinner{width:24px;height:24px;border:3px solid rgba(0,71,171,.15);border-top-color:#0047AB;border-radius:50%;animation:iaSpin .7s linear infinite;margin:auto;}

.ia-banner{display:flex;align-items:center;gap:10px;padding:12px 16px;border:1.5px solid;border-radius:9px;font-weight:600;font-size:.85rem;margin-bottom:14px;animation:iaPop .3s ease;}
.ia-banner-success{background:rgba(32,96,61,.1);border-color:rgba(32,96,61,.3);color:#20603D;}
.ia-banner-warning{background:rgba(224,123,0,.08);border-color:rgba(224,123,0,.3);color:#e07b00;}
.ia-banner-info{background:rgba(0,71,171,.07);border-color:rgba(0,71,171,.25);color:#0047AB;}
.ia-banner-danger{background:rgba(192,57,43,.08);border-color:rgba(192,57,43,.3);color:#c0392b;}

.ia-select-all-row{display:flex;align-items:center;gap:8px;padding:8px 12px;background:#f8fafc;border-radius:7px;margin-bottom:10px;font-size:.81rem;font-weight:600;color:#374151;}
.ia-locked{pointer-events:none;opacity:.6;filter:grayscale(.2);}
.ia-step-tabs{display:flex;gap:8px;margin-bottom:14px;flex-wrap:wrap;}

@media(max-width:640px){
  .ia-summary{grid-template-columns:repeat(2,1fr);}
  .ia-row{grid-template-columns:1fr;}
}
`;

/* ─── helpers ─────────────────────────────────────────────────── */
const uid = () => Math.random().toString(36).slice(2, 9);
const LS_KEY = "isiboAttendanceV3";
const loadLS = () => { try { return JSON.parse(localStorage.getItem(LS_KEY)) || { activities: [], attendance: [] }; } catch { return { activities: [], attendance: [] }; } };
const saveLS = (d) => { try { localStorage.setItem(LS_KEY, JSON.stringify(d)); } catch {} };

const fmtDate = (d) => { if (!d) return "—"; try { return new Date(d).toLocaleDateString("rw-RW", { year: "numeric", month: "long", day: "numeric" }); } catch { return String(d); } };
const nowISO = () => new Date().toISOString();

const getUserInfo = () => {
  try {
    const p = JSON.parse(atob((localStorage.getItem("token") || "").split(".")[1]));
    return { name: p.fullname || p.username || "Isibo", id: p.id || p.user_id || null };
  } catch { return { name: "Isibo", id: null }; }
};

const genderBadge = (g = "") => {
  const v = g.toLowerCase();
  if (v === "gore" || v === "f") return <span className="ia-badge ia-badge-gore">Gore</span>;
  if (v === "gabo" || v === "m") return <span className="ia-badge ia-badge-gabo">Gabo</span>;
  return <span className="ia-badge ia-badge-other">{g || "—"}</span>;
};

const StatusBadge = ({ s }) => {
  const m = {
    DRAFT:     { cls: "ia-status-draft",     label: "✏ Draft" },
    SAVED:     { cls: "ia-status-saved",     label: "💾 Byabitswe" },
    SUBMITTED: { cls: "ia-status-submitted", label: "📤 Yoherejwe" },
    APPROVED:  { cls: "ia-status-approved",  label: "✅ Yemejwe" },
    RETURNED:  { cls: "ia-status-returned",  label: "↩ Yarsubijwe" },
  };
  const d = m[s] || m.DRAFT;
  return <span className={`ia-status ${d.cls}`}>{d.label}</span>;
};

const exportCSV = (act, citizens, att) => {
  const rows = [["Amazina", "Igitsina", "Icyiciro", "Attendance"].join(","),
    ...citizens.map(c => {
      const r = att.find(a => a.citizen_id === c.id && a.activity_id === act.id);
      return [`"${c.full_name}"`, c.igitsina || "—", c.category || "—", r?.status || "—"].join(",");
    })];
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([rows.join("\n")], { type: "text/csv" }));
  a.download = `attendance-${act.activity_name}-${act.activity_date}.csv`;
  a.click();
};

const printPDF = (act, citizens, att, summary) => {
  const rows = citizens.map(c => {
    const r = att.find(a => a.citizen_id === c.id && a.activity_id === act.id);
    const st = r?.status;
    return `<tr><td>${c.full_name}</td><td>${c.igitsina || "—"}</td><td>${c.category || "—"}</td><td style="color:${st === "YES" ? "#20603D" : st === "NO" ? "#c0392b" : "#94a3b8"};font-weight:700">${st === "YES" ? "✓ Yego" : st === "NO" ? "✗ Oya" : "—"}</td></tr>`;
  }).join("");
  const w = window.open("", "_blank");
  w.document.write(`<html><head><title>Attendance — ${act.activity_name}</title>
  <style>body{font-family:sans-serif;font-size:13px;padding:24px}h2{color:#0047AB}table{border-collapse:collapse;width:100%}th,td{border:1px solid #ddd;padding:7px 10px}th{background:#0047AB;color:#fff}p{color:#555}</style></head>
  <body><h2>📋 Attendance: ${act.activity_name}</h2>
  <p>Itariki: ${fmtDate(act.activity_date)}</p>
  <p>Abaturage Bose: <strong>${summary.total}</strong> | Yego: <strong style="color:#20603D">${summary.yes}</strong> | Oya: <strong style="color:#c0392b">${summary.no}</strong> | Attendance: <strong style="color:#e07b00">${summary.pct}%</strong></p>
  <table><thead><tr><th>Amazina</th><th>Igitsina</th><th>Icyiciro</th><th>Attendance</th></tr></thead><tbody>${rows}</tbody></table>
  </body></html>`);
  w.document.close(); w.print();
};

/* ══════════════════════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════════════════════ */
export default function IsiboAttendance() {
  /* ── local persisted store ── */
  const [store, setStore] = useState(loadLS);
  const persist = useCallback((fn) => {
    setStore(prev => {
      const next = fn(JSON.parse(JSON.stringify(prev)));
      saveLS(next);
      return next;
    });
  }, []);

  /* ── citizens from abaturage table ── */
  const [citizens, setCitizens] = useState([]);
  const [citizensLoading, setCitizensLoading] = useState(false);

  /* ── activities from server ── */
  const [serverActivities, setServerActivities] = useState([]);
  const [activitiesLoading, setActivitiesLoading] = useState(false);

  /* ── UI state ── */
  const [activeActId, setActiveActId] = useState(null);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [draftAtt, setDraftAtt] = useState({}); // { citizen_id: 'YES'|'NO' }
  const [search, setSearch] = useState("");
  const [step, setStep] = useState("select"); // select | mark | summary
  const [banner, setBanner] = useState(null);
  const [showNewActModal, setShowNewActModal] = useState(false);
  const [showConfirmSend, setShowConfirmSend] = useState(false);
  const [newAct, setNewAct] = useState({ activity_name: "", activity_date: new Date().toISOString().slice(0, 10), description: "" });
  const [saving, setSaving] = useState(false);
  const [correctionNote, setCorrectionNote] = useState("");
  const endRef = useRef(null);

  const showBanner = useCallback((type, msg, ms = 4000) => {
    setBanner({ type, msg });
    setTimeout(() => setBanner(null), ms);
  }, []);

  /* ── Load household heads (abakuru b'ingo) — Attendance is registered
     against household heads, not every citizen ── */
  useEffect(() => {
    const load = async () => {
      setCitizensLoading(true);
      try {
        // Scoped to this Isibo's own data via the same getDataFilter() the
        // rest of the app uses.
        const res = await axiosInstance.get("/isibo/household-heads");
        const rows = Array.isArray(res.data) ? res.data : [];
        const mapped = rows.map(p => ({
          id: String(p.umuturage_id || p.id || uid()),
          full_name: p.full_name || [p.izina_ribanza, p.izina_risoza].filter(Boolean).join(" ").trim() || `Umuturage #${p.umuturage_id}`,
          igitsina: p.igitsina || "",
          category: p.icyiciro_cy_imibereho || p.category || "Umukuru w'Urugo",
        })).filter(p => p.full_name);
        setCitizens(mapped);
      } catch {
        // demo fallback
        setCitizens([
          { id: "d1", full_name: "Uwimana Jean Claude", igitsina: "Gabo", category: "Abaturage" },
          { id: "d2", full_name: "Mukamana Marie Claire", igitsina: "Gore", category: "Abaturage" },
          { id: "d3", full_name: "Habimana Pierre", igitsina: "Gabo", category: "Abaturage" },
          { id: "d4", full_name: "Ingabire Grace", igitsina: "Gore", category: "Abaturage" },
        ]);
      } finally { setCitizensLoading(false); }
    };
    load();
  }, []);

  /* ── Load activities from server ── */
  const loadActivities = useCallback(async () => {
    setActivitiesLoading(true);
    try {
      const res = await axiosInstance.get("/isibo-attendance/activities");
      if (Array.isArray(res.data)) setServerActivities(res.data);
    } catch { /* use localStorage */ }
    finally { setActivitiesLoading(false); }
  }, []);

  useEffect(() => { loadActivities(); }, [loadActivities]);

  /* Merge server + localStorage activities */
  const allActivities = useMemo(() => {
    if (serverActivities.length > 0) return serverActivities;
    return store.activities;
  }, [serverActivities, store.activities]);

  const activeActivity = allActivities.find(a => String(a.id || a.activity_id) === String(activeActId));

  /* filtered citizens */
  const filteredCitizens = useMemo(() => {
    if (!search) return citizens;
    const q = search.toLowerCase();
    return citizens.filter(c => c.full_name.toLowerCase().includes(q));
  }, [citizens, search]);

  /* saved records for active activity */
  const savedRecs = useMemo(() =>
    store.attendance.filter(a => String(a.activity_id) === String(activeActId)),
  [store.attendance, activeActId]);

  const isLocked = activeActivity?.status === "SUBMITTED" || activeActivity?.status === "APPROVED";
  const isReturned = activeActivity?.status === "RETURNED";

  /* attendance summary */
  const summary = useMemo(() => {
    const vals = Object.values(draftAtt);
    const yes = vals.filter(v => v === "YES").length;
    const no = vals.filter(v => v === "NO").length;
    const total = selectedIds.size;
    return { total, yes, no, pct: total > 0 ? Math.round((yes / total) * 100) : 0 };
  }, [draftAtt, selectedIds]);

  /* restore draft when activity changes */
  useEffect(() => {
    if (!activeActId) { setDraftAtt({}); setSelectedIds(new Set()); return; }
    const saved = store.attendance.filter(a => String(a.activity_id) === String(activeActId));
    if (saved.length) {
      const draft = {};
      const ids = new Set();
      saved.forEach(a => { draft[String(a.citizen_id)] = a.status; ids.add(String(a.citizen_id)); });
      setDraftAtt(draft); setSelectedIds(ids);
      setStep("mark");
    } else { setDraftAtt({}); setSelectedIds(new Set()); setStep("select"); }
    // check correction note from server activity
    const act = allActivities.find(a => String(a.id || a.activity_id) === String(activeActId));
    if (act?.mudugudu_comment) setCorrectionNote(act.mudugudu_comment);
  }, [activeActId]); // eslint-disable-line

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [step]);

  /* ── actions ── */
  const createActivity = async () => {
    if (!newAct.activity_name.trim()) return;
    const act = { id: uid(), ...newAct, status: "DRAFT", created_at: nowISO() };
    // try server
    try {
      const res = await axiosInstance.post("/isibo-attendance/activities", {
        activity_name: act.activity_name, activity_date: act.activity_date, description: act.description
      });
      if (res.data?.activity_id) act.id = String(res.data.activity_id);
    } catch {}
    persist(s => { s.activities.unshift(act); return s; });
    setActiveActId(act.id);
    setShowNewActModal(false);
    setNewAct({ activity_name: "", activity_date: new Date().toISOString().slice(0, 10), description: "" });
    showBanner("success", `Igikorwa «${act.activity_name}» gishyizweho neza.`);
    loadActivities();
  };

  const toggleCitizen = id => {
    const sid = String(id);
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(sid)) { next.delete(sid); setDraftAtt(d => { const n = { ...d }; delete n[sid]; return n; }); }
      else next.add(sid);
      return next;
    });
  };

  const markAtt = (cid, status) => setDraftAtt(p => ({ ...p, [String(cid)]: status }));

  const buildRecords = actId => {
    const { name } = getUserInfo();
    const recs = [];
    selectedIds.forEach(cid => {
      const c = citizens.find(x => String(x.id) === String(cid));
      recs.push({ id: uid(), activity_id: actId, citizen_id: cid, citizen_name: c?.full_name || "", status: draftAtt[String(cid)] || "NO", marked_by: name, created_at: nowISO() });
    });
    return recs;
  };

  const saveAttendance = async () => {
    if (!activeActId) return;
    setSaving(true);
    const act = allActivities.find(a => String(a.id || a.activity_id) === String(activeActId));
    const records = buildRecords(activeActId);
    try {
      await axiosInstance.post("/isibo-attendance/save", {
        activity_id: activeActId, activity_name: act?.activity_name,
        activity_date: act?.activity_date, description: act?.description, records,
      });
    } catch {}
    persist(s => {
      s.attendance = s.attendance.filter(a => String(a.activity_id) !== String(activeActId));
      s.attendance.push(...records);
      const idx = s.activities.findIndex(a => String(a.id) === String(activeActId));
      if (idx !== -1) s.activities[idx].status = "SAVED";
      return s;
    });
    setSaving(false);
    showBanner("success", "✓ Attendance yabitswe neza.");
    setStep("summary");
  };

  const sendToMudugudu = async () => {
    setSaving(true);
    const act = allActivities.find(a => String(a.id || a.activity_id) === String(activeActId));
    const records = buildRecords(activeActId);
    try {
      await axiosInstance.post("/isibo-attendance/submit", {
        activity_id: activeActId, activity_name: act?.activity_name,
        activity_date: act?.activity_date, description: act?.description, records,
      });
    } catch {}
    const ts = nowISO();
    persist(s => {
      s.attendance = s.attendance.filter(a => String(a.activity_id) !== String(activeActId));
      s.attendance.push(...records);
      const idx = s.activities.findIndex(a => String(a.id) === String(activeActId));
      if (idx !== -1) { s.activities[idx].status = "SUBMITTED"; s.activities[idx].submitted_at = ts; }
      return s;
    });
    setSaving(false);
    setShowConfirmSend(false);
    showBanner("success", "🎉 Attendance yoherejwe ku Mudugudu neza.");
    loadActivities();
  };

  /* ══════════ RENDER ══════════ */
  return (
    <>
      <style>{S}</style>
      <div className="ia-root">

        {/* Header */}
        <div className="ia-hdr">
          <div>
            <h2>📋 Attendance for Citizens</h2>
            <p>Abitabiriye Ibikorwa — {allActivities.length} ibikorwa</p>
          </div>
          <button className="ia-btn ia-btn-primary" onClick={() => setShowNewActModal(true)}>
            ➕ Igikorwa Gishya
          </button>
        </div>

        {/* Banner */}
        {banner && (
          <div className={`ia-banner ia-banner-${banner.type}`}>
            {banner.type === "success" ? "✓" : banner.type === "warning" ? "⚠" : banner.type === "danger" ? "✗" : "ℹ"} {banner.msg}
          </div>
        )}

        {/* ── STEP A: Select Activity ── */}
        <div className="ia-card">
          <div className="ia-card-head">
            <div className="ia-card-head-icon">📅</div>
            Hitamo Igikorwa / Umuganda
          </div>
          <div className="ia-card-body">
            {activitiesLoading && <div style={{ textAlign: "center", padding: 16 }}><div className="ia-spinner" /></div>}
            {!activitiesLoading && allActivities.length === 0 && (
              <div className="ia-empty">
                <div style={{ fontSize: 48, opacity: .35 }}>📋</div>
                <div style={{ fontWeight: 700, color: "#374151" }}>Nta Gikorwa Kihari</div>
                <div style={{ fontSize: ".8rem" }}>Kanda 'Igikorwa Gishya' wongeraho igikorwa</div>
                <button className="ia-btn ia-btn-primary ia-btn-sm" style={{ marginTop: 8 }} onClick={() => setShowNewActModal(true)}>
                  ➕ Igikorwa Gishya
                </button>
              </div>
            )}
            {allActivities.map(act => {
              const actId = String(act.id || act.activity_id);
              return (
                <div key={actId} className={`ia-act-item${activeActId === actId ? " selected" : ""}`}
                  onClick={() => setActiveActId(actId)}>
                  <div className="ia-act-icon">📅</div>
                  <div className="ia-act-body">
                    <div className="ia-act-name">{act.activity_name}</div>
                    <div className="ia-act-meta">
                      {fmtDate(act.activity_date)}
                      {act.description && <span> — {act.description}</span>}
                    </div>
                    {act.mudugudu_comment && act.status === "RETURNED" && (
                      <div style={{ fontSize: ".73rem", color: "#c0392b", marginTop: 3, fontStyle: "italic" }}>
                        ↩ Impamvu yo Gukosora: {act.mudugudu_comment}
                      </div>
                    )}
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                    <StatusBadge s={act.status || "DRAFT"} />
                    {activeActId === actId && <span style={{ color: "#0047AB" }}>▸</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ── STEP B–D: Work area (when activity selected) ── */}
        {activeActivity && (() => {
          const actId = String(activeActivity.id || activeActivity.activity_id);
          return (
            <div className={isLocked ? "ia-locked" : ""}>

              {/* Locked notice */}
              {isLocked && (
                <div className="ia-banner ia-banner-info">
                  🔒 Iyi raporo yoherejwe ku Mudugudu kuwa {fmtDate(activeActivity.submitted_at)}.
                  Ntishobora guhindurwa.
                </div>
              )}

              {/* Returned for correction notice */}
              {isReturned && (
                <div className="ia-banner ia-banner-danger">
                  ↩ Raporo yakugaruwe n'Umudugudu kugira ikorehe.
                  {activeActivity.mudugudu_comment && (
                    <span> Impamvu: <strong>{activeActivity.mudugudu_comment}</strong></span>
                  )}
                </div>
              )}

              {/* Step tabs */}
              <div className="ia-step-tabs">
                {[
                  { id: "select", label: "① Hitamo Abaturage" },
                  { id: "mark",   label: "② Shyiraho Attendance" },
                  { id: "summary", label: "③ Incamake" },
                ].map(t => (
                  <button key={t.id}
                    className={`ia-btn ia-btn-sm${step === t.id ? " ia-btn-primary" : " ia-btn-outline"}`}
                    onClick={() => setStep(t.id)}>
                    {t.label}
                  </button>
                ))}
              </div>

              {/* ── SELECT CITIZENS ── */}
              {step === "select" && (
                <div className="ia-card">
                  <div className="ia-card-head">
                    <div className="ia-card-head-icon">👥</div>
                    Abaturage ({citizens.length}) — Hitamo abazitabira
                  </div>
                  <div className="ia-card-body">
                    {citizensLoading && <div style={{ textAlign: "center", padding: 20 }}><div className="ia-spinner" /></div>}

                    <div className="ia-filter-bar">
                      <div className="ia-search">
                        <i className="bi bi-search" />
                        <input placeholder="Shakisha amazina..." value={search} onChange={e => setSearch(e.target.value)} />
                      </div>
                    </div>

                    <div className="ia-select-all-row">
                      <input type="checkbox" className="ia-cb"
                        checked={filteredCitizens.length > 0 && filteredCitizens.every(c => selectedIds.has(String(c.id)))}
                        onChange={e => {
                          if (e.target.checked) setSelectedIds(new Set(filteredCitizens.map(c => String(c.id))));
                          else { setSelectedIds(new Set()); setDraftAtt({}); }
                        }} />
                      <span>Hitamo bose ({filteredCitizens.length})</span>
                      {selectedIds.size > 0 && <span style={{ color: "#0047AB", fontWeight: 700 }}>— {selectedIds.size} bahiswemo</span>}
                    </div>

                    <div className="ia-table-wrap">
                      <table className="ia-table">
                        <thead>
                          <tr>
                            <th>☑</th>
                            <th>Amazina</th>
                            <th>Igitsina</th>
                            <th>Icyiciro</th>
                            <th>Attendance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredCitizens.length === 0
                            ? <tr><td colSpan={5} style={{ textAlign: "center", padding: "20px", color: "#94a3b8" }}>Nta muturage ubonetse</td></tr>
                            : filteredCitizens.map(c => {
                              const sid = String(c.id);
                              const checked = selectedIds.has(sid);
                              return (
                                <tr key={sid} onClick={() => toggleCitizen(sid)} style={{ cursor: "pointer" }}>
                                  <td><input type="checkbox" className="ia-cb" checked={checked} onChange={() => toggleCitizen(sid)} onClick={e => e.stopPropagation()} /></td>
                                  <td style={{ fontWeight: 500 }}>{c.full_name}</td>
                                  <td>{genderBadge(c.igitsina)}</td>
                                  <td style={{ fontSize: ".75rem", color: "#64748b" }}>{c.category}</td>
                                  <td>
                                    {checked
                                      ? <div className="ia-toggle" onClick={e => e.stopPropagation()}>
                                          <button className={`ia-tog-yes${draftAtt[sid] === "YES" ? " active" : ""}`} onClick={() => markAtt(sid, "YES")}>✔ Yego</button>
                                          <button className={`ia-tog-no${draftAtt[sid] === "NO" ? " active" : ""}`} onClick={() => markAtt(sid, "NO")}>✗ Oya</button>
                                        </div>
                                      : <span style={{ color: "#94a3b8", fontSize: ".75rem" }}>Hitamo</span>
                                    }
                                  </td>
                                </tr>
                              );
                            })
                          }
                        </tbody>
                      </table>
                    </div>

                    <div style={{ marginTop: 14, display: "flex", gap: 10, flexWrap: "wrap" }}>
                      <button className="ia-btn ia-btn-primary" disabled={selectedIds.size === 0}
                        onClick={() => setStep("mark")}>
                        ▸ Komeza ({selectedIds.size} bahiswemo)
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* ── MARK ATTENDANCE ── */}
              {step === "mark" && (
                <div className="ia-card">
                  <div className="ia-card-head">
                    <div className="ia-card-head-icon">✅</div>
                    Shyiraho Attendance — {activeActivity.activity_name}
                  </div>
                  <div className="ia-card-body">

                    {/* Live summary */}
                    <div className="ia-summary">
                      <div className="ia-sum-box" style={{ borderTop: "3px solid #0047AB" }}>
                        <div className="ia-sum-num" style={{ color: "#0047AB" }}>{summary.total}</div>
                        <div className="ia-sum-lbl">Abaturage Bose</div>
                      </div>
                      <div className="ia-sum-box" style={{ borderTop: "3px solid #20603D" }}>
                        <div className="ia-sum-num" style={{ color: "#20603D" }}>{summary.yes}</div>
                        <div className="ia-sum-lbl">Bitabiriye (Yego)</div>
                      </div>
                      <div className="ia-sum-box" style={{ borderTop: "3px solid #c0392b" }}>
                        <div className="ia-sum-num" style={{ color: "#c0392b" }}>{summary.no}</div>
                        <div className="ia-sum-lbl">Ntibitabiriye (Oya)</div>
                      </div>
                      <div className="ia-sum-box" style={{ borderTop: "3px solid #e07b00" }}>
                        <div className="ia-sum-num" style={{ color: "#e07b00" }}>{summary.pct}%</div>
                        <div className="ia-sum-lbl">Attendance Rate</div>
                        <div className="ia-progress"><div className="ia-progress-fill" style={{ width: `${summary.pct}%` }} /></div>
                      </div>
                    </div>

                    <div className="ia-table-wrap">
                      <table className="ia-table">
                        <thead>
                          <tr>
                            <th>Amazina</th>
                            <th>Igitsina</th>
                            <th>Icyiciro</th>
                            <th>Attendance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {citizens.filter(c => selectedIds.has(String(c.id))).map(c => (
                            <tr key={c.id}>
                              <td style={{ fontWeight: 500 }}>{c.full_name}</td>
                              <td>{genderBadge(c.igitsina)}</td>
                              <td style={{ fontSize: ".75rem", color: "#64748b" }}>{c.category}</td>
                              <td>
                                <div className="ia-toggle">
                                  <button className={`ia-tog-yes${draftAtt[String(c.id)] === "YES" ? " active" : ""}`}
                                    onClick={() => markAtt(String(c.id), "YES")} disabled={isLocked}>
                                    ✔ Yego
                                  </button>
                                  <button className={`ia-tog-no${draftAtt[String(c.id)] === "NO" ? " active" : ""}`}
                                    onClick={() => markAtt(String(c.id), "NO")} disabled={isLocked}>
                                    ✗ Oya
                                  </button>
                                  {!draftAtt[String(c.id)] && <span style={{ color: "#94a3b8", fontSize: ".73rem", padding: "5px 8px" }}>—</span>}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div style={{ marginTop: 16, display: "flex", gap: 10, flexWrap: "wrap" }}>
                      {!isLocked && (
                        <button className="ia-btn ia-btn-success" disabled={saving} onClick={saveAttendance}>
                          {saving ? "Birimo…" : "💾 Bika Attendance"}
                        </button>
                      )}
                      <button className="ia-btn ia-btn-outline" onClick={() => setStep("select")}>← Subira inyuma</button>
                    </div>
                  </div>
                </div>
              )}

              {/* ── SUMMARY ── */}
              {step === "summary" && (
                <div className="ia-card" ref={endRef}>
                  <div className="ia-card-head">
                    <div className="ia-card-head-icon">📊</div>
                    Incamake — {activeActivity.activity_name}
                  </div>
                  <div className="ia-card-body">

                    <div className="ia-summary">
                      {[
                        { n: summary.total, l: "Abaturage Bose", c: "#0047AB" },
                        { n: summary.yes,   l: "Bitabiriye (Yego)", c: "#20603D" },
                        { n: summary.no,    l: "Ntibitabiriye (Oya)", c: "#c0392b" },
                        { n: `${summary.pct}%`, l: "Attendance Rate", c: "#e07b00" },
                      ].map(s => (
                        <div key={s.l} className="ia-sum-box" style={{ borderTop: `3px solid ${s.c}` }}>
                          <div className="ia-sum-num" style={{ color: s.c }}>{s.n}</div>
                          <div className="ia-sum-lbl">{s.l}</div>
                        </div>
                      ))}
                    </div>

                    <div className="ia-table-wrap" style={{ marginBottom: 16 }}>
                      <table className="ia-table">
                        <thead>
                          <tr>
                            <th>Amazina</th>
                            <th>Igitsina</th>
                            <th>Icyiciro</th>
                            <th>Attendance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {citizens.filter(c => selectedIds.has(String(c.id))).map(c => {
                            const rec = savedRecs.find(r => String(r.citizen_id) === String(c.id));
                            const st = rec?.status || draftAtt[String(c.id)];
                            return (
                              <tr key={c.id}>
                                <td style={{ fontWeight: 500 }}>{c.full_name}</td>
                                <td>{genderBadge(c.igitsina)}</td>
                                <td style={{ fontSize: ".75rem", color: "#64748b" }}>{c.category}</td>
                                <td>
                                  <span style={{ fontWeight: 700, color: st === "YES" ? "#20603D" : st === "NO" ? "#c0392b" : "#94a3b8" }}>
                                    {st === "YES" ? "✓ Yego" : st === "NO" ? "✗ Oya" : "—"}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Actions */}
                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                      {!isLocked && (activeActivity.status === "SAVED" || activeActivity.status === "DRAFT" || isReturned) && (
                        <button className="ia-btn ia-btn-primary" onClick={() => setShowConfirmSend(true)}>
                          📤 Ohereza Attendance ku Mudugudu
                        </button>
                      )}
                      <button className="ia-btn ia-btn-outline ia-btn-sm"
                        onClick={() => exportCSV(activeActivity, citizens.filter(c => selectedIds.has(String(c.id))), savedRecs)}>
                        📥 Excel
                      </button>
                      <button className="ia-btn ia-btn-outline ia-btn-sm"
                        onClick={() => printPDF(activeActivity, citizens.filter(c => selectedIds.has(String(c.id))), savedRecs, summary)}>
                        🖨 PDF
                      </button>
                      {!isLocked && (
                        <button className="ia-btn ia-btn-outline ia-btn-sm" onClick={() => setStep("mark")}>
                          ✎ Hindura
                        </button>
                      )}
                    </div>

                    {isLocked && (
                      <div className="ia-banner ia-banner-info" style={{ marginTop: 14 }}>
                        🔒 Raporo yoherejwe — {fmtDate(activeActivity.submitted_at)}. Guhindura bifunze.
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })()}

        {/* ═══ NEW ACTIVITY MODAL ═══ */}
        {showNewActModal && (
          <div className="ia-overlay" onClick={e => e.target === e.currentTarget && setShowNewActModal(false)}>
            <div className="ia-modal">
              <h3>➕ Igikorwa Gishya</h3>
              <div className="ia-row">
                <div>
                  <label className="ia-label">Izina ry'Igikorwa *</label>
                  <input className="ia-input" placeholder="Umuganda, Inama…" value={newAct.activity_name}
                    onChange={e => setNewAct(p => ({ ...p, activity_name: e.target.value }))} autoFocus />
                </div>
                <div>
                  <label className="ia-label">Itariki *</label>
                  <input className="ia-input" type="date" value={newAct.activity_date}
                    onChange={e => setNewAct(p => ({ ...p, activity_date: e.target.value }))} />
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label className="ia-label">Ibisobanuro (birihwanye)</label>
                <input className="ia-input" placeholder="Ibisobanuro by'igikorwa…" value={newAct.description}
                  onChange={e => setNewAct(p => ({ ...p, description: e.target.value }))} />
              </div>
              <div className="ia-modal-btns">
                <button className="ia-btn ia-btn-success" disabled={!newAct.activity_name.trim()} onClick={createActivity}>
                  💾 Bika Igikorwa
                </button>
                <button className="ia-btn ia-btn-outline" onClick={() => setShowNewActModal(false)}>Hagarika</button>
              </div>
            </div>
          </div>
        )}

        {/* ═══ CONFIRM SEND TO MUDUGUDU ═══ */}
        {showConfirmSend && (
          <div className="ia-overlay" onClick={e => e.target === e.currentTarget && setShowConfirmSend(false)}>
            <div className="ia-modal">
              <h3>📤 Ohereza Attendance ku Mudugudu</h3>
              <p style={{ color: "#374151", fontSize: ".88rem", lineHeight: 1.6, marginBottom: 14 }}>
                Uremeza ko ushaka kohereza iyi attendance ku Mudugudu?
              </p>
              <div style={{ background: "#f0f6ff", borderRadius: 8, padding: "12px 14px", fontSize: ".82rem", color: "#0047AB", marginBottom: 8 }}>
                <strong>{activeActivity?.activity_name}</strong><br />
                Itariki: {fmtDate(activeActivity?.activity_date)}<br />
                Abaturage: {summary.total} | Yego: {summary.yes} | Oya: {summary.no} | {summary.pct}%
              </div>
              <p style={{ fontSize: ".77rem", color: "#e07b00", marginBottom: 4 }}>
                ⚠ Nyuma yo kohereza, ntushobora gusubira guhindura.
              </p>
              <div className="ia-modal-btns">
                <button className="ia-btn ia-btn-primary" disabled={saving} onClick={sendToMudugudu}>
                  {saving ? "Birimo…" : "Yego — Ohereza"}
                </button>
                <button className="ia-btn ia-btn-outline" onClick={() => setShowConfirmSend(false)}>Oya</button>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}
